"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation sendUserPhoneAuthentication($email: String, $phoneNumber: String, $isLogin:Boolean) {
    sendUserPhoneAuthentication(email: $email, phoneNumber: $phoneNumber, isLogin: $isLogin)
  }
`;
exports.default = query;
//# sourceMappingURL=sendUserPhoneAuthentication.mutation.js.map